import React, { useState, useRef, useEffect } from "react";
import DepartmentPopup from "./DepartmentPopup";
import styles from "./EmployeeList.module.scss";

const DepartmentChips = ({ departments }) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsPopupVisible(false);
      }
    };

    if (isPopupVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupVisible]);

  let departmentList = [];
  if (typeof departments === "string") {
    departmentList = departments.split(",");
  } else if (Array.isArray(departments)) {
    departmentList = departments;
  }

  if (departmentList.length === 0) {
    return null;
  }

  return (
    <div className={styles.chipsContainer} ref={popupRef}>
      <span className={styles.countChip}>
        {departmentList.length} department
        {departmentList.length !== 1 ? "s" : ""}
      </span>

      <span className={styles.moreChip} onClick={() => setIsPopupVisible(true)}>
        ...
      </span>

      {isPopupVisible && (
        <DepartmentPopup
          departments={departmentList}
          onClose={() => setIsPopupVisible(false)}
        />
      )}
    </div>
  );
};

export default DepartmentChips;
